import { render, staticRenderFns } from "./ProcedureItem.vue?vue&type=template&id=13b162fb"
import script from "./ProcedureItem.vue?vue&type=script&lang=js"
export * from "./ProcedureItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports